import { toPhoneNumber } from '@hourly/utilities';

export class SalesRepresentative {
  name: string;
  email: string;
  phoneNumber: string;

  constructor(name: string = '-', phoneNumber: string = '-', email: string = '-') {
    this.name = name;
    this.email = email;
    this.phoneNumber = phoneNumber;
  }

  get phoneNumberFormatted(): string {
    return toPhoneNumber(this.phoneNumber);
  }
}
